"use strict";
/* istanbul ignore file */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentStatus = exports.DirectDebitInfo = void 0;
var DirectDebitInfo;
(function (DirectDebitInfo) {
    DirectDebitInfo["HARDREFUSED"] = "HARDREFUSED";
    DirectDebitInfo["SOFTREFUSED"] = "SOFTREFUSED";
    DirectDebitInfo["ONGOING"] = "ONGOING";
    DirectDebitInfo["MANUAL"] = "MANUAL";
})(DirectDebitInfo = exports.DirectDebitInfo || (exports.DirectDebitInfo = {}));
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["ONGOING_PAYMENT"] = "ONGOING_PAYMENT";
    PaymentStatus["OPEN"] = "OPEN";
    PaymentStatus["PAID"] = "PAID";
    PaymentStatus["OVERDUE"] = "OVERDUE";
    PaymentStatus["NOT_REFUNDED"] = "NOT_REFUNDED";
    PaymentStatus["REFUNDED"] = "REFUNDED";
    PaymentStatus["INSTALMENT"] = "INSTALMENT";
})(PaymentStatus = exports.PaymentStatus || (exports.PaymentStatus = {}));
